import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

/**
 * 菜节点
 */
@ccclass
export default class CaiNode extends cc.Component {

    @property
    mIndex : number = 0;
    @property(cc.Node)
    caiSpirit : cc.Node = null;

    onLoad () {
        O1HD.on("CaiNode.pick" , this.pick , this );
        O1HD.on("CaiNode.active" , this.active , this );
    }

    start () {

    }

    pick( index : number , callback ){
        if ( this.mIndex == index ) {
            this.caiSpirit.active = false;
            callback && callback(this.node.convertToWorldSpaceAR(cc.v2()));
        }
    }

    active(){
        this.caiSpirit.active = true;
    }
}

